import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    padding: 33px 60px;
    background-color: #2E2D37;
    flex: 1;

    .content-header {
      
      svg {
        width: 40px;
        height: 46px;
        display: inline-block;
        vertical-align: middle;
        margin-top: 5px;
        fill: #FF1540;
      }
    }
    .content-title {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.light};
        font-size: 17px;
        text-align: center;
        min-height: 50px;
        h4 {
            font-family: Poppins, Heltica, Arial, sans-serif;
            font-weight: medium;
            font-size: 23px;
            letter-spacing: 0;
            color: ${colors.light};        
            vertical-align: middle;
            margin-bottom: 0;
            display: inline-block;
            line-height: 21px;
            margin-top: 25px;
        }
    }

      span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 10px;
        line-height: 21px;
      }

    
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.light};
        font-size: 17px;
        text-align: center;
        min-height: 50px;
        margin-top: 25px;
    }

    @media screen and (max-width: 1919px) {
        padding: 33px 33px;

        .content-header {
      svg {
        width: 30px;
        height: 35px;
      }
    }
    .content-title {
    h4 {
        font-size: 18px;
        line-height: 21px;
        margin-top: 10px;
      }
    }

      span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 10px;
        line-height: 21px;
      }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.light};
        font-size: 12px;
        text-align: center;
        margin-top: 5px;
        min-height: 40px;
    }
}
@media screen and (max-width: ${ScreenSize.tablet}px) {
    padding: 33px 33px 0;
    .content-title {
    h4 {
        min-height: 10px;
        font-size: 16px;
        }
    }
    .content-body {    
        margin-top: 0;
        min-height: 80px;
    }
  }
@media screen and (max-width: ${ScreenSize.portrait}px) {
    padding: 33px 33px 0;
    .content-title {
    h4 {
        min-height: 10px;
        font-size: 16px;
        }
    }
    .content-body {    
        margin-top: 0;
        min-height: 0;
    }
  }
`;
